import * as React from "react";
import { forwardRef } from "react";
const GeoArrowSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M20.212 3.793a1 1 0 0 1 .227 1.066L14.09 21.364a1 1 0 0 1-1.907-.134l-1.764-7.644-7.644-1.763a1 1 0 0 1-.134-1.908l16.505-6.348a1 1 0 0 1 1.066.226M6.41 10.608l5.068 1.17a1 1 0 0 1 .75.75l1.17 5.068 4.367-11.355z", clipRule: "evenodd" }));
const ForwardRef = forwardRef(GeoArrowSVG);
export default ForwardRef;
//# sourceMappingURL=GeoArrow.js.map